import { USER_KEY } from '@/constants'

export default () => {
  const { chainId } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return chainId
}
